<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/typography';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';

```jsx import
import {Heading} from '@react-spectrum/typography';
```

---
category: Content
---

# Heading

<p>{docs.exports.Heading.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Heading']}
  sourceData={[
    {type: 'Spectrum', url: 'https://spectrum.adobe.com/page/typography/'}
  ]} />

## Example

```tsx example
<Heading>Edit</Heading>
```

## Content

[View guidelines](https://spectrum.adobe.com/page/typography/#Heading)

Heading is a [Typography](https://spectrum.adobe.com/page/typography)
component which is a child to other components. Heading provides
hierarchical information, like a title within a Dialog, based on placement
within a parent component. Based on the component Heading is used within, it
gets Spectrum styling and may have a preassigned slot for positioning. By
virtue of its name, the Heading component provides semantic meaning in the
context they are placed. Examples of their usage in [Dialog](Dialog.html#example) and
[IllustratedMessage](IllustratedMessage.html#example). It is important to note
that the Heading component accepts any renderable node, not just strings.

See [the MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements) for more information.

## Props

<PropTable component={docs.exports.Heading} links={docs.links} />
